import React, { useState } from "react";
import "../styles/biosurgeFAQ.css";
import { FaChevronDown, FaChevronUp, FaQuestionCircle, FaLeaf, FaShieldAlt, FaClock } from "react-icons/fa";

const faqs = [
  {
    id: 1,
    question: "How should I consume BioSurge Majun?",
    answer: "Take one teaspoon (approx 5–10g) daily, preferably with warm milk after dinner. Regular use as part of a balanced routine is suggested."
  },
  {
  id: 2,
  question: "Is BioSurge a medicine?",
  answer: "No, BioSurge is a herbal wellness supplement and is not intended to diagnose, treat, cure, or prevent any disease."
},
  {
    id: 3,
    question: "Are there any precautions?",
    answer: "BioSurge is a herbal wellness blend made with traditional ingredients. If you have any existing health condition or concerns, consult a healthcare professional before use."
  },
  {
    id: 4,
    question: "When can I expect to experience benefits?",
    answer: "Herbal products work gradually and may be experienced differently by each individual depending on lifestyle and consistency of use."
  },
  {
    id: 5,
    question: "Is it suitable for diabetic individuals?",
    answer: "BioSurge contains a honey-based blend. Individuals managing blood sugar levels should consult their healthcare professional before use."
  },
  {
    id: 6,
    question: "Can it be used alongside an active lifestyle?",
    answer: "BioSurge is designed to complement a balanced diet and active lifestyle by supporting general wellbeing and daily energy."
  },
  {
    id: 7,
    question: "What are the storage instructions?",
    answer: "Store in a cool, dry place away from direct sunlight. Keep the jar tightly closed after every use."
  }
];

const BioSurgeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bs-faq-section">
      <div className="bs-faq-container">
        
        {/* Header Section */}
        <div className="bs-faq-header">
          <div className="bs-badge">
            <FaLeaf size={12} /> <span>100% Natural Support</span>
          </div>
          <h2 className="bs-faq-title">Got Questions? <br/> <span className="green-text">We've Got Answers.</span></h2>
          <p className="bs-faq-subtitle">Everything you need to know about BioSurge and your journey to peak performance.</p>
        </div>

        {/* FAQ Grid */}
        <div className="bs-faq-grid">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id} 
              className={`bs-faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <div 
                className="bs-faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                <div className="question-left">
                    <span className="q-number">0{index + 1}</span>
                    <span className="bs-faq-question-text">{faq.question}</span>
                </div>
                <div className="bs-faq-icon">
                  {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>
              
              <div className={`bs-faq-answer-wrapper ${openIndex === index ? 'open' : ''}`}>
                <div className="bs-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div> 
      </div>
    </section>
  );
};

export default BioSurgeFAQ;